/**
 * Componente que muestra el contador de personas en el radar.
 * Muestra el total de usuarios encontrados con un icono de radar.
 * Memoizado para evitar renders innecesarios.
 * 
 * @param {Object} props - Propiedades del componente
 * @param {number} props.totalPersonas - Total de personas encontradas
 */

import { memo } from 'react';
import NotificationCounter from './NotificationCounter';

function RadarCounter({ totalPersonas }) {
  console.log('[RadarCounter] Rendering with totalPersonas:', totalPersonas);

  return (
    <div className="sticky top-20 z-10 h-12 bg-neutral-800 px-4 flex items-center justify-between gap-2">
      <span className="text-white py-2">
        {totalPersonas} personas cerca
      </span>

      {/* Contador de notificaciones */}
      <NotificationCounter />

    </div>
  );
}

// Memoizar el componente para evitar renders innecesarios
export default memo(RadarCounter);
